import { useEffect, useState } from "react";

/**
 * 호(4자리) 한글 명칭 조회 — 관세율표 품명 일치 배너가 "제4015호(고무로 만든 의류…)"처럼 부모 호의 조건을
 * 이름 옆에 붙이는 데 쓴다. `/api/onto/chapter-headings?chapter=NN`(공개, 류당 1회)을 모듈 캐시에 담는다. fail-open.
 */
const chapterCache = new Map(); // chapter -> Promise<{hs4: title_ko}>

export function shortHeadingTitle(title, max = 44) {
  const text = String(title || "").replace(/\s+/g, " ").trim();
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1)}…`;
}

export function loadHeadingTitles(chapter, fetchImpl = fetch) {
  const padded = String(chapter || "").padStart(2, "0");
  if (!/^\d{2}$/.test(padded)) return Promise.resolve({});
  if (!chapterCache.has(padded)) {
    const promise = fetchImpl(`/api/onto/chapter-headings?chapter=${padded}`)
      .then((response) => (response && response.ok ? response.json() : null))
      .then((data) => {
        const out = {};
        for (const heading of Array.isArray(data?.headings) ? data.headings : []) {
          if (heading && heading.hs4) out[String(heading.hs4)] = String(heading.title_ko || heading.title_en || "");
        }
        return out;
      })
      .catch(() => ({}));
    chapterCache.set(padded, promise);
  }
  return chapterCache.get(padded);
}

/** 테스트용 캐시 초기화. */
export function resetHeadingTitleCache() {
  chapterCache.clear();
}

/** hs4 목록의 한글 호 명칭. 아직 못 받았으면 빈 객체. */
export function useHeadingTitles(hs4List, fetchImpl = fetch) {
  const key = (Array.isArray(hs4List) ? hs4List : []).map(String).filter(Boolean).sort().join(",");
  const [titles, setTitles] = useState({});
  useEffect(() => {
    if (!key) return undefined;
    let alive = true;
    const chapters = [...new Set(key.split(",").map((hs4) => hs4.slice(0, 2)))];
    Promise.all(chapters.map((chapter) => loadHeadingTitles(chapter, fetchImpl))).then((maps) => {
      if (!alive) return;
      const merged = {};
      for (const map of maps) Object.assign(merged, map);
      setTitles(merged);
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return titles;
}
